import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Alert({ title, message }) {
    return (_jsx("div", { className: "z-200 top-0 flex w-full justify-center px-4 py-3 pb-5", style: styles.alert, children: _jsxs("div", { className: "max-w-lg", children: [_jsx("h3", { className: "mt-0 font-medium", children: title }), _jsx("h5", { className: "mt-1 text-xs", children: message })] }) }));
}
const styles = {
    alert: {
        color: '#815924',
        backgroundColor: '#FFEBD2',
    },
};
